const getters = {
    getMyFunction: (state, getters, rootState, rootGetters) => {
        return  rootGetters["users/getMe"] &&  rootGetters["users/getMe"].customClaims ? rootGetters["users/getMe"].customClaims.description : null;
    },
    getPageVisibility: (state, getters, rootState, rootGetters) => (page) => {
        if (page === 'team-lead') {
            const myFunction = getters.getMyFunction;
            console.log(state,rootGetters["users/getMe"]);
            const visibleFor = ['root', 'Operationeel Directeur', 'Teamleider', 'Assistent Teamleider', 'Manager Warehouse', 'Manager Facilitair & Salarisadministratie','Manager vestiging','Algemeen directeur'];
            return visibleFor.indexOf(myFunction) > -1;
        } else  if (page === 'cycle-count') {
            const myFunction = getters.getMyFunction;
            const visibleFor = ['root', 'Operationeel Directeur', 'Teamleider', 'Assistent Teamleider', 'Manager Warehouse', 'Manager Facilitair & Salarisadministratie','Manager vestiging', 'Algemeen directeur'];
            return visibleFor.indexOf(myFunction) > -1;
        } else {
            return true;
        }
    }
}

export default getters